const REQUEST_SUCCESS = 'request-success'
const REQUEST_ERROR = 'request-error'

export { REQUEST_ERROR, REQUEST_SUCCESS }
